import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'

firebase.initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID
})

// TODO: enable emulators when working on localhost
// https://firebase.google.com/docs/emulator-suite

// if (
//   location.hostname === 'localhost' ||
//   process.env.NODE_ENV === 'development'
// ) {
//   firebase.auth().useEmulator('http://localhost:9099')
//   firebase.firestore().useEmulator('localhost', 8081)
//   firebase.functions().useEmulator('localhost', 5001)
// }

const { Timestamp } = firebase.firestore
export { Timestamp }

export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
export const functions = firebase
  .app()
  .functions(process.env.VUE_APP_PROJECT_REGION)
